import { render, staticRenderFns } from "./AdminTeacherVisits.vue?vue&type=template&id=2d733758&scoped=true&"
import script from "./AdminTeacherVisits.vue?vue&type=script&lang=js&"
export * from "./AdminTeacherVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d733758",
  null
  
)

export default component.exports